import WelcomeBar from './WelcomeBar'

export default WelcomeBar
